import React from 'react';
import { FormattedMessage } from 'react-intl';
import Heading from '@starbucks-web/pattern-library/lib/components/heading';

import DropdownSizeSelector from './dropdown-size-selector';
import IconSizeSelector from './icon-size-selector';

import { usePdpContext } from '../pdp-provider';

import messages from './messages';

const SizeSelector = () => {
  const {
    product: { productType },
    sizeInfo,
  } = usePdpContext();
  const showSizeSelector =
    sizeInfo?.isWholeBean ||
    (productType === 'beverages' && sizeInfo?.sizeNames?.length > 1);

  if (!showSizeSelector) return null;

  const showIconSizeSelector =
    !sizeInfo?.hasUnsupportedIconSizeCodes || sizeInfo?.isWholeBean;
  const showDropdownSizeSelector = showSizeSelector && !showIconSizeSelector;

  return (
    <React.Fragment>
      <Heading
        bottomBorder
        className="mb5 text-semibold"
        size="md"
        tagName="h2"
      >
        <FormattedMessage {...messages.sizeOptionsTitle} />
      </Heading>
      {showDropdownSizeSelector && <DropdownSizeSelector />}
      {showIconSizeSelector && <IconSizeSelector />}
    </React.Fragment>
  );
};

export default SizeSelector;
